import PageRoutes from './routes'

function App() {
	return (
		<div className="serif-font bg-neutral-100 overflow-x-hidden">
			<PageRoutes />
		</div>
	)
}

export default App
